module.exports = __webpack_public_path__ + "static/media/douroluz.078cae5c.png";